import { atom } from 'recoil';

export const refreshBbrSelectorAtom = atom<object>({
    key: 'refreshBbrSelectorAtom',
    default: {}
});
